/**
 *
 * WebViews
 *
 */

import React from 'react';
import { withRouter, Switch, Route } from 'react-router';
import FuelRegistration from './FuelRegistration/FuelRegistration';
import InstallerPayoutDashboard from './InstallerPayoutDashboard/InstallerPayoutDashboard';
import TermsForGPS from './Website/TermsForGPS/TermsForGPS';
import Teammate from './Teammate/Teammate';
import './WebViews.scss';

const WebViews = (props) => {
  let routes = (
    <Switch>
      <Route path="/web/fuel-registration" component={FuelRegistration} />
      <Route path="/web/hulk/installer-payout-dashboard" component={InstallerPayoutDashboard} />
      <Route path="/web/site/terms-for-gps" component={TermsForGPS} />
      <Route path="/web/operator/teammate" component={Teammate} />
    </Switch>
  );

  return <div className="webview-container">{routes}</div>;
};

export default withRouter(WebViews);
